import { render, staticRenderFns } from "./AssessmentCompetenceEgrPro.vue?vue&type=template&id=a601f18e&scoped=true"
import script from "./AssessmentCompetenceEgrPro.vue?vue&type=script&lang=js"
export * from "./AssessmentCompetenceEgrPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a601f18e",
  null
  
)

export default component.exports